import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const ChartContainer = styled.div``;

export const BarChartContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(2.5)} ${theme.spacing(3)} ${theme.spacing(1)}`};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.backgroundExtended.card};
`;

export const BarChartHeader = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: block;
  padding-bottom: ${({ theme }) => theme.spacing(1.5)};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const BarChartValue = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h5)};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const CalendarContainer = styled.div``;
